export const VehicleType = [
    {label: 'Vehicle Type', value: 'DEFAULT'},
    {label: 'Car', value: 'CAR'},
    {label: 'Van', value: 'VAN'},
    {label: 'High Roof Van', value: 'VAN_HIGH_ROOF'},
    {label: 'Mini Bus', value: 'MINI_BUS'}
];